export { default as PlaySolid } from './Play-Solid.svg';
export { default as SongWaveform } from './Song-Wave.svg';
export { default as CalendarPlusOutline } from './Calendar-Plus-Outline.svg';
export { default as CalendarPlusSolid } from './Calendar-Plus-Solid.svg';
export { default as ReportsOutline } from './Reports-Outline.svg';
export { default as ReportsSolid } from './Reports-Solid.svg';
export { default as UserNeckOutline } from './User-Neck-Outline.svg';
export { default as UserNeckSolid } from './User-Neck-Solid.svg';
export { default as SocialProfileOutline } from './SocialProfile-Outline.svg';
export { default as SocialProfileSolid } from './SocialProfile-Solid.svg';